import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Amplify } from 'aws-amplify';
import { AuthService } from 'src/core/services/auth.service';
import { NavigationEnd, Router } from "@angular/router";
import { UtilsService } from 'src/core/services/utils.service';
import { AppAuthUser } from 'src/core/models/auth-user';
import { PORTAL_DASHBOARD_ROLES } from 'src/core/config/portal-route-roles';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.auth.userPoolId,
      userPoolClientId: environment.auth.userPoolWebClientId,
      identityPoolId: environment.auth.identityPoolId,
    },
  },
});


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'magalies-pharma';
  init: boolean = false;

  // for side nav — default matches toolbar height until main-nav is measured
  fixedTopGap: number = 64;

  currentUser: AppAuthUser | null = null;
  currentRoles: string[] = [];
  showAccountDetails: boolean = false;

  constructor(
    private _auth: AuthService,
    private _router: Router,
    private location: Location,
    private utils: UtilsService
  ) { }


  async ngOnInit() {

    this.init = await this._auth.authenticateUser();

    this
      ._auth
      .currentUserChanges()
      .subscribe((user) => {
        this.currentUser = user;
        if (this.currentUser) {
          this.redirectFromPortalShellIfNeeded();
        }
      });

    this
      ._auth
      .currentRolesChanges()
      .subscribe((roles) => {
        this.currentRoles = roles;
      });

    this
      .utils
      .onMainNavHeightChanged()
      .subscribe(height => {
        this.fixedTopGap = height;
      });

    this._router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
      this.redirectFromPortalShellIfNeeded();
    });
  }

  /** /portal has no child view — send signed-in staff to their default landing page. */
  private redirectFromPortalShellIfNeeded(): void {
    if (!this.currentUser) {
      return;
    }

    const roles = this._auth.getRoles();
    // Customers use another site — do not deep-link into portal routes (guard signs them out).
    if (roles.includes('Customer')) {
      return;
    }

    const path = this.location.path().split(/[?#]/)[0];
    if (path !== '/portal') {
      return;
    }

    const canOpenDashboard = roles.some((r) =>
      PORTAL_DASHBOARD_ROLES.includes(r)
    );
    void this._router.navigate([
      canOpenDashboard ? '/portal/dashboard' : '/portal/prescriptions',
    ]);
  }
  async signOut() {
    await this._auth.signOut();
  }


  getFirstLetterOfName(user: AppAuthUser | null) {
    if (!user) return ":/";
    const name = user.attributes?.name;
    return name?.[0] ?? user.username[0] ?? '?';
  }

  autoCloseAccountDetails() {
    this.showAccountDetails = false;
  }
}
